define([
    "dojo/_base/declare",
    "csi/reflection",
    "csi/table/New"
], function(declare,reflection,New) {

    return declare(New, {
        getActionView: function(/*csi.def.ViewRef?*/vr) {
            // summary: set the m_typeNode to the appropriate subclass of the StructureItem
            var cache = this.getCache();
            var node = cache.getNode(this.m_urlParent,true);
            var relation = reflection.getRelation(node, this.relation.m_id);
            this.m_typeNode = relation.getDestinationClass().m_type;
            return this.inherited(arguments);
        }
    });
});